import React from "react";
import styles from "./TooltipTemplate.module.css";
import { Tooltip } from "devextreme-react";
import escapeId from "Common/stringUtils/escapeId";
function TooltipTemplate({ id, showTooltip = true, position = "top", maxWidth = "70%", children, ...props }) {
    return (React.createElement(Tooltip, { showEvent: "mouseenter", hideEvent: "mouseleave", hideOnOutsideClick: false, wrapperAttr: {
            class: styles["alert-wrapper"]
        }, target: `#${escapeId(id)}`, position: position, maxWidth: maxWidth, disabled: !(children && showTooltip), ...props },
        React.createElement("div", null, children)));
}
export default TooltipTemplate;
